import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
  ColorInput,
  Text,
  Select,
  NumberInput,
  ActionIcon, 
  Stack,
} from "@mantine/core";
import classes from "./edit.module.css";
import { RowDataTerms } from "./types";
import { Dropzone } from "@mantine/dropzone";
import { IconX, IconPlus } from "@tabler/icons-react";

interface EditTermsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onEditTerms: (editedTermsData: RowDataTerms) => void;
  termsData: RowDataTerms;
}

const EditTermsModal: React.FC<EditTermsModalProps> = ({
  isOpen,
  onClose,
  onEditTerms,
  termsData,
}) => {
  const [editedTerms, setEditedTerms] = useState<RowDataTerms>(termsData);

  const [terms, setTerms] = useState<string[]>([])
  const [termInput, setTermInput] = useState<string>('')

  useEffect(() => {
    setEditedTerms(termsData);
    setTerms(termsData?.content ? JSON.parse(termsData?.content) : [])
  }, [termsData]);

  useEffect(()=>{
    setEditedTerms({ ...termsData, content: JSON.stringify(terms) })
  },[terms.length])

  const handleEdit = () => {
    // Perform validation or additional logic as needed

    if(terms.length === 0){
        alert("Please fill in all the required fields");
        return;
    }

    if (!editedTerms.title || !editedTerms.content 
    ) {
      alert("Please fill in all the required fields");
      return;
    }

    onEditTerms(editedTerms);
    onClose();
  };

  const addTerm = () => {
    if(termInput.trim().length < 1){
        alert("Please enter term");
        return;
    }
    terms.push(termInput.trim())
    setTermInput('')
}

const removeTerm = (index: number) => {
    setTerms(terms=> terms.filter((s,i)=>(i != index)))
}

  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Edit Terms & Conditions
        </div>
      }
      opened={isOpen}
      onClose={onClose}
      size={'lg'}
    >
      
      <TextInput
        label="Title"
        maxLength={255}
        mb="sm"
        value={editedTerms.title}
        onChange={(event) =>
            setEditedTerms({ ...editedTerms, title: event.currentTarget.value })
        }
      />

        <Stack gap={4} mb="sm">
        {terms.length > 0 ? <Text className={classes.Text}>Terms & Conditions</Text> : null}
        {terms.map((item, i)=>(
            <div key={i} style={{display: 'flex', gap: 10, width: '100%'}}>
                <div style={{flex: 1}}>
                <TextInput
                    // disabled={createvenueMutation.isLoading}
                    value={item}
                    readOnly
                />
                </div>
                <ActionIcon onClick={() => removeTerm(i)} size='lg' variant="outline" color='red'>
                    <IconX size={20} />
                </ActionIcon>
            </div>
        ))
        }
        </Stack>
        

        <Text className={classes.Text}>Add Term</Text>
        <div style={{display: 'flex', gap: 10, width: '100%'}}>
            <div style={{flex: 1}}>
                <TextInput
                // label="Terms"
                placeholder="Input term"
                mb="sm"
                maxLength={255}
                value={termInput}
                onChange={(event) =>
                    setTermInput(event.currentTarget.value)
                }
                />
            </div>
            <ActionIcon onClick={() => addTerm()} size='lg' variant="outline" color='green'>
                <IconPlus size={20} />
            </ActionIcon>
        </div>

      <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonCancel}>
          Back
        </Button>
        <Button onClick={handleEdit} className={classes.buttonSaveChanges}>
          Save Changes
        </Button>
      </Group>
    </Modal>
  );
};

export default EditTermsModal;
